"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SharingHead = void 0;
var _head = _interopRequireDefault(require("next/head"));
var _jsxRuntime = require("react/jsx-runtime");
const SharingHead = ({
  description,
  pageMetaImage,
  title,
  androidBanner,
  iosBanner,
  url
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_head.default, {
  children: [(pageMetaImage && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("link", {
      rel: "image_src",
      href: pageMetaImage.url
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
      name: "thumb",
      content: pageMetaImage.url
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
      property: "og:image",
      content: pageMetaImage.url
    }), pageMetaImage.width != null && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
      property: "og:image:width",
      content: pageMetaImage.width.toString()
    }), pageMetaImage.height != null && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
      property: "og:image:height",
      content: pageMetaImage.height.toString()
    })]
  })) ?? '', (url && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
    property: "og:url",
    content: url
  })) ?? '', (description && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
      name: "introText",
      content: description
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
      name: "description",
      content: description
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
      property: "og:description",
      content: description
    })]
  })) ?? '', (title && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
      name: "header",
      content: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
      name: "title",
      content: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
      property: "og:title",
      content: title
    })]
  })) ?? '', (androidBanner && /*#__PURE__*/(0, _jsxRuntime.jsx)("link", {
    rel: "manifest",
    href: androidBanner
  })) ?? '', (iosBanner && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
    name: "apple-itunes-app",
    content: iosBanner
  })) ?? '']
});
exports.SharingHead = SharingHead;
